import React, { useState } from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import { IUser, IReply } from '@src/types/course';
import { formatToDate } from '@src/utils/time';
import Message from './message';
import ReplyMessageOperator from './replyMessageOperator';

const ExpandButton = styled.div`
	padding: 0;
	color: #3091FD;
	cursor: pointer;
	padding: 12px 0px;
	width: 100%;
	text-align: left;
	border-top: 1px solid #E9E9E9;
`;

const MessageReplies = styled.div`
	margin-top: 20px;
	& > *:last-child {
		padding-bottom: 0px;
	}
`;

interface IMessages {
	commentId: string;
	message: string;
	user: IUser;
	createAt: string;
	replies: IReply[];
}

const Messages = ({
	commentId, message, user, createAt, replies,
}: IMessages):JSX.Element => {
	const { t } = useTranslation();
	const [expandReplies, setExpandReplies] = useState(false);
	const hasReply = replies.length > 0;

	const handleExpandMessages = () => {
		setExpandReplies(true);
	};

	return (
		<Message
			avatarLink={user.profile_picture_link?.link}
			authorName={user.name}
			role={user.role}
			message={message}
			bought={user.bought}
			createAt={createAt}
		>
			{hasReply && (
				<MessageReplies>
					{!expandReplies && replies.length > 2 && (
						<ExpandButton onClick={handleExpandMessages}>{t('course:discussions:expand_all')}</ExpandButton>
					)}
					{replies
						.slice(expandReplies ? 0 : replies.length - 2, replies.length)
						.map(reply => (
							<Message
								key={reply.id}
								avatarLink={reply.user.profile_picture_link?.link}
								role={reply.user.role}
								authorName={reply.user.name}
								isReplier
								createAt={formatToDate(reply.created_at)}
								message={reply.message}
								bought={reply.user.bought}
							/>
						))}
				</MessageReplies>
			)}
			<ReplyMessageOperator
				commentId={commentId}
			/>
		</Message>
	);
};

export default Messages;
